
import React, { useState, useEffect, useRef } from "react";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import BackArrows from "../../Form/BackArrow/BackArrows";
import { ToastContainer } from "react-toastify";
import { IoSearch } from "react-icons/io5";
import { MdFilterListAlt } from "react-icons/md";
import { Sidebar } from "primereact/sidebar";
import {
  getStatusBgColor,
  interestLevel,
  leadStatusMap,
  statusIcons,
} from "../../../Enum";
import { FaChevronDown } from "react-icons/fa";
import Select, { components } from "react-select";
import LocationService from "../../Services/LocationService";
import teamService from "../../Services/TeamService";
import leadSourceService from "../../Services/LeadSourceService";
import userServices from "../../Services/UserService";
import LeadTable from "../../Form/LeadTable/LeadTable";
import LeadDbService from "../../Services/LeadDbService";
// import LeadFilterSidebar from "./LeadFilterSidebar";
import { useLocation, useNavigate } from "react-router-dom";

import { showErrorToast, showInfoToast } from "../../Constant/Notification";
import { teamIds, teamList } from "../../../utils/storage";
import { format } from "date-fns";
import LeadDbBulkHistoryService from "../../Services/LeadDbBulkHistoryService";
import { leadCharacterEmoji } from "../../Constant/Constant";
import BulkLeadUploadDataFilter from "./BulkLeadUploadDataFilter";
import CustomHeading from "../../common/CustomHeading";
import { status } from "../../../Enum/LeadEnumConstants";

const BulkLeadUploadData = () => {
  const location = useLocation();
  console.log(location.state);

 
  const batchId = location.state.batchId;
  const userId = location.state?.userId || null;
  const teamId = location.state?.teamId || null;
  const filterOpen = location.state?.filterOpen;

  console.log(
    "Team Id",
    Array.isArray(teamIds) && teamIds.length > 0 ? teamIds[0] : "No teamId"
  );


const defaultTeamId = Array.isArray(teamIds) && teamIds.length > 0 ? teamIds[0] : teamId;


  const [filterVisible, setFilterVisible] = useState(filterOpen || false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [interestLocationTags, setInterestedLocationTags] = useState([]);
  const [optionLocation, setOptionLocation] = useState([]);
  const [leadSources, setLeadSources] = useState([]);
  const [teams, setTeams] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(userId || null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedTeam, setSelectedTeam] = useState(defaultTeamId || null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startType, setStartType] = useState("text");
  const [endType, setEndType] = useState("text");
  const [searchQuery, setSearchQuery] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [leads, setLeads] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [nextPageToken, setNextPageToken] = useState(null);
  const [prevPageToken, setPrevPageToken] = useState(null);
  const [hasMoreLeads, setHasMoreLeads] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [leadCache, setLeadCache] = useState({});
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("userData"));
  const userRole = userData?.user?.role;
  const [showReassignModal, setShowReassignModal] = useState(false);
  const [loading, setLoading] = useState(false);



  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "transparent",
      border: "none",
      boxShadow: "none",
    }),
  };

  const getBackgroundClass = (label) => {
    switch (label.toLowerCase()) {
      case "gold":
        return "bg-gradient-to-b from-[#FFB947] to-[#ECCD90] bg-clip-text text-transparent";
      case "silver":
        return "bg-gradient-to-b from-[#B6B6B6] to-[#E8E8E8] bg-clip-text text-transparent";
      case "bronze":
        return "bg-gradient-to-b from-[#BA7E5E] via-[#FF9F6B] to-[#411904] bg-clip-text text-transparent";
      case "diamond":
        return "bg-gradient-to-b from-[#0563FF] to-[#4085F8] bg-clip-text text-transparent";
      default:
        return "text-black";
    }
  };

  const handleLeadInfo = (lead) => {
    console.log("Lead object:", lead);
    console.log("Lead ID:", lead.id);
    let path = "";
    if (userRole === "Admin") {
      path = `/admin/lead-info/${lead.id}`;
    } else if (userRole === "CMO") {
      path = `/cmo/lead-info/${lead.id}`;
    } else if (userRole === "MD") {
      path = `/md/lead-info/${lead.id}`;
    } else if (userRole === "BOD") {
      path = `/bod/lead-info/${lead.id}`;
    }
    navigate(path, { state: { lead } });
  };

  const columns = [
    {
      key: "name",
      title: "Name",
      render: (text, record) => (
        <div
          onClick={() => handleLeadInfo(record)}
          title={text.replace(/\b\w/g, (char) => char.toUpperCase())}
          className="text-blue-500 w-[160px] truncate cursor-pointer text-center"
        >
          {text.replace(/\b\w/g, (char) => char.toUpperCase())}
        </div>
      ),
    },
    {
      key: "phoneNumber",
      title: "Phone Number",
      render: (text, record) => (
        <div className="w-[160px] truncate text-center">
          +{record.countryCode} {record.phoneNumber}
        </div>
      ),
    },
    {
      key: "status",
      title: "Status",
      render: (value) => {
        const matchedStatus = statusIcons.find((item) => item.label === value);
        if (!matchedStatus)
          return <span className="text-gray-600 text-center w-full">Unknown</span>;
  
        return (
          <div
            className={`${getStatusBgColor(
              matchedStatus?.label
            )} flex items-center justify-center text-center w-44 px-2 gap-2 rounded-full`}
          >
            <img
              src={matchedStatus.image}
              alt={matchedStatus.label}
              className="w-5 h-5"
            />
            <span className="text-gray-700">{matchedStatus.label}</span>
          </div>
        );
      },
    },
    {
      key: "lastAct",
      title: "Last Act",
      render: (text) => {
        let bgColor = "";
        if (text <= 5) {
          bgColor =
            "border-[#98DDFF] border bg-blue-100";
        } else if (text <= 10) {
          bgColor =
            "border-[#FFA64D] border bg-orange-100";
        } else {
          bgColor =
            "border-[#EE6C4D] border bg-red-100";
        }
  
        const label = text > 1 ? "days" : "day";
        return (
          <span
            className={`${bgColor} text-gray-600 px-3 py-1 rounded-full flex items-center justify-center w-full`}
          >
            <div className="flex items-center gap-1">
              <div>{text}</div>
              <div>{label}</div>
            </div>
          </span>
        );
      },
    },
    {
      key: "character",
      title: "Character",
      render: (text) => {
        return (
          <div className="flex items-center justify-center">
            <img
              className="w-5"
              src={
                leadCharacterEmoji[text] || leadCharacterEmoji["Not Applicable"]
              }
              alt={text || "N/A"}
            />
          </div>
        );
      },
    },
    {
      key: "quality",
      title: "Lead Quality",
      render: (value) => {
        const matchedQuality = interestLevel.find(
          (item) => item.label === value
        );
  
        return (
          <div className="flex items-center justify-center gap-2 text-center">
            {matchedQuality?.label && (
              <>
              <img
              src={matchedQuality.image  }
              alt={matchedQuality.label}
              className="w-5 h-5"
            />
            <span className={`${getBackgroundClass(matchedQuality.label)}`}>
            {matchedQuality.label || "Not Quality"} 
          </span>
          </>
            )}
            
           
          </div>
        );
      },
    },
    {
      key: "location",
      title: "Location",
      render: (value) => {
        const firstLocation = value?.[0]?.name || "No Location";
        const extraCount = value?.length > 1 ? ` +${value.length - 1}` : "";
        const fullTitle = value?.map((loc) => loc.name).join(", ");
  
        return (
          <span
            className="inline-block cursor-pointer max-w-[170px] truncate whitespace-nowrap overflow-hidden text-center"
            title={fullTitle}
          >
            {firstLocation}
            <span className="text-blue-500">{extraCount}</span>
          </span>
        );
      },
    },
    {
      key: "teamName",
      title: "Team",
      render: (value) => {
        return (
          <div
            title={value}
            className="w-[100px] truncate cursor-pointer text-center"
          >
            {value}
          </div>
        );
      },
    },
    {
      key: "userName",
      title: "Assigned To",
      render: (value) => {
        return (
          <div
            title={value}
            className="w-[100px] truncate cursor-pointer text-center"
          >
            {value}
          </div>
        );
      },
    },
  ];

  const formatDate = (date) => {
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const year = d.getFullYear();
    return `${month}-${day}-${year}`;
  };

  const formattedStartDate = startDate ? formatDate(startDate) : "";
  const formattedEndDate = endDate ? formatDate(endDate) : "";

  const removalCountRef = useRef(0);

  const applyFilter = (removalChip) => {
    if (startDate && !endDate) {
      showErrorToast("End Date is required when Start Date is selected.");
      return;
    }
  
    console.log("applyFilter", removalChip);
  
    // Compute what the new state will be after the chip is removed
    const level = removalChip === "quality" ? null : selectedLevel;
    const status = removalChip === "status" ? null : selectedStatus;
    const location = removalChip === "location" ? null : interestLocationTags;
    const team = removalChip === "team" ? null : selectedTeam;
    const user = removalChip === "user" ? null : selectedUser;
    const start = removalChip === "startDate" ? null : formattedStartDate;
    const end = removalChip === "startDate" ? null : formattedEndDate;
  
    const noFiltersSelected =
      !level &&
      !status &&
      (!location || location.length === 0) &&
      !team &&
      !user ;
  
    if (noFiltersSelected) {
      showInfoToast("No filters selected. Please apply at least one.");
    
      setLeads([]);
      setHasMoreLeads(false);
      setLeadCache({});
      return;
    }
  
    const newPageSize = 10;
    setLeadCache({});
  
    handleApplyFilter(null, "reset", newPageSize, 1, removalChip);
    console.log("Applying filter with removal chip:", removalChip);
  };
  

  const handleApplyFilter = async (
    pageToken = null,
    direction = "next",
    limitOverride = null,
    overridePage = null,
    removalChip
  ) => {
    setLoading(true);
    console.log("handleApplyFilter", removalChip);
    try {
      let targetPage = overridePage ?? currentPage;

      if (direction === "next") {
        targetPage += 1;
      } else if (direction === "previous") {
        targetPage = Math.max(targetPage - 1, 1);
      } else if (direction === "reset") {
        targetPage = 1;
      }

      if (leadCache[targetPage] && !removalChip) {
        const cached = leadCache[targetPage];
        setLeads(cached.leads);
        setNextPageToken(cached.next);
        setPrevPageToken(cached.prev);
        setHasMoreLeads(!!cached.next);
        setCurrentPage(targetPage);
        return;
      }

      const body = {
        searchKey: searchQuery || null,
        role : userRole,
        batchId : batchId,
        status: removalChip == "status" ? null : selectedStatus || null,
        quality: removalChip == "quality" ? null : selectedLevel?.label || null,
        location:
          removalChip == "location"
            ? null
            : interestLocationTags?.value || null,
        team: removalChip == "team" ? null : selectedTeam || defaultTeamId,
        user: removalChip == "user" ? null : selectedUser || null,
        startDate:
          removalChip == "startDate" ? null : formattedStartDate || null,
        endDate: removalChip == "startDate" ? null : formattedEndDate || null,
        limit: limitOverride ?? pageSize,
        next: direction === "next" ? pageToken : null,
        previous: direction === "previous" ? pageToken : null,
        direction,
      };

      const filterData = await LeadDbBulkHistoryService.getBulkUploadLeadData(body);
      const newLeads = filterData.data.leads;
      const newNext = filterData.data.next;
      const newPrev = filterData.data.prev;

      setLeadCache((prev) => ({
        ...prev,
        [targetPage]: {
          leads: newLeads,
          next: newNext,
          prev: newPrev,
        },
      }));

      setFilterVisible(false);
      setLeads(newLeads);
      setNextPageToken(newNext);
      setPrevPageToken(newPrev);
      setHasMoreLeads(!!newNext);
      setCurrentPage(targetPage);
    } catch (error) {
      console.error("Error fetching filtered leads:", error);
    } finally {
      setLoading(false);
    }
  };

  const isFirstRender = useRef(true);

  useEffect(() => {
    

    handleApplyFilter(null, "reset", pageSize, 1, true);
  }, [pageSize , batchId]);

  const handlePageChange = (tokenOrValue, direction) => {
    console.log(tokenOrValue);
    if (direction === "size") {
      const newPageSize = parseInt(tokenOrValue, 10);
      setPageSize(newPageSize);
      setCurrentPage(1);
      setLeadCache({});
      setNextPageToken(null);
      setPrevPageToken(null);
      handleApplyFilter(null, "reset", newPageSize, 1);
    } else if (direction === "next") {
      setCurrentPage((prev) => prev + 1);
      handleApplyFilter(nextPageToken, "next");
    } else if (direction === "previous") {
      setCurrentPage((prev) => Math.max(prev - 1, 1));
      handleApplyFilter(prevPageToken, "previous");
    }
  };

  const clearFilterData = () => {
    return new Promise((resolve) => {
      setSelectedStatus("");
      setSelectedLevel(null);
      setInterestedLocationTags([]);
      setSelectedTeam("");
      setSelectedUser("");
      setStartDate("");
      setEndDate("");
      setErrors({});
      resolve();
    });
  };

  const handleClearAndApplyFilter = async () => {
    await clearFilterData();
    applyFilter();
  };

  const handleSelectionChange = (selectedIds) => {
    setSelectedRows(selectedIds);
    console.log("All selected IDs:", selectedIds);
  };

  useEffect(() => {
    (async () => {
      try {
        const responseLocation = await LocationService.fetchLocation();
        const dataLocation = responseLocation.data;
        const formattedLocations = Object.entries(dataLocation).map(
          ([name, id]) => ({
            value: id,
            label: name,
          })
        );

        setOptionLocation(formattedLocations);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }

      try {
        const response = await teamService.getTeamName();
        const data = response.data?.teams || [];
        setTeams(data);
      } catch (error) {
        console.error("Error fetching teams:", error);
      }
    })();
  }, []);

  useEffect(() => {
    const fetchTeamUsers = async () => {
      if (!selectedTeam) {
        setUsers([]);
        return;
      }

      setIsLoading(true);
      try {
        const selected = selectedTeam || defaultTeamId;
        const response = await teamService.getTeamData(selected);
        const data = response.data;

        const combinedUsers = [
          ...(Array.isArray(data.BOD) && data.BOD.length > 0
            ? data.BOD.map((bod) => ({ name: bod.name, id: bod.id }))
            : []),
          ...(data.MD && data.MD.name !== null && data.MD.id !== null
            ? [{ name: data.MD.name, id: data.MD.id }]
            : []),
          ...(Array.isArray(data.members) && data.members.length > 0
            ? data.members.map((member) => ({
                name: member.name,
                id: member.id,
              }))
            : []),
        ];

        const finalUsers = combinedUsers.length > 0 ? combinedUsers : [];
        setUsers(finalUsers);
      } catch (error) {
        console.error("Error fetching team users:", error);
        setUsers([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTeamUsers();
  }, [selectedTeam]);

  const handleBack = () => {
    window.history.back();
  };

  const handleFilterLeads = () => {
    setFilterVisible(true);
  };

  const handleStatusChange = (e) => {
    console.log(e);
    setSelectedStatus(e);
  };

  const handleSelectChange = (selectedOption) => {
    console.log(selectedOption);
    setSelectedLevel(selectedOption);
  };

  const handleLocationChange = (event) => {
    setInterestedLocationTags(event);
  };

  const handleTeamChange = (value) => {
    setSelectedTeam(value);
    setSelectedUser("");
  };

  const handleSearchLead = () => {
    setLeadCache({});

    handleApplyFilter();
  };

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <FaChevronDown className="text-customGreen" />
      </components.DropdownIndicator>
    );
  };

  const getLocalDate = () => {
    const now = new Date();
    const offset = now.getTimezoneOffset();
    const localDate = new Date(now.getTime() - offset * 60 * 1000);
    return localDate.toISOString().split("T")[0];
  };

  const path =
    userRole === "Admin" ? "/admin" : userRole === "CMO" ? "/cmo" : "/bod";

  const handleReasignTeam = () => {
    navigate(`${path}/lead/reassign`, {
      state: {
        leadListArray: selectedRows,
        teamId: selectedTeam,
        memberId: selectedUser,
        leadCount: selectedRows.length,
      },
    });
  };

  const handleRemoveStatus = () => {
    setSelectedStatus(null);

    applyFilter("status");
  };

  const handleRemoveLevel = () => {
    setSelectedLevel(null);
    applyFilter("quality");
  };

  const handleRemoveLocation = (loc) => {
    setInterestedLocationTags(null);
    applyFilter("location");
  };

  const handleRemoveTeam = () => {
    setSelectedTeam(null);
    setSelectedUser(null);
    applyFilter("team");
  };

  const handleRemoveUser = () => {
    setSelectedUser(null);
    applyFilter("user");
  };

  const handleRemoveDate = () => {
    setStartDate(null);
    setEndDate(null);
    applyFilter("startDate");
  };

  console.log("Location ", interestLocationTags);

  const handleReasignOtherTeam = () => {};

  console.log("Selected User:", selectedUser);
  console.log("Selected Team:", selectedTeam);
  return (
    <div className="pt-14 bg-appGrayBackground ">
       <AdminAppBar />
      <ToastContainer />
      <div className="mt-[50px] px-6">
        <div className="flex flex-col gap-6">
          <div className="flex items-center justify-between">
            <CustomHeading title={"Bulk Upload Leads Data"} isIcon={true} />
            
              <div className="flex items-center gap-5">
                {/* Status */}
                {selectedStatus && (
                  <div className="flex items-center gap-2 bg-customGreen text-white px-3 py-1 rounded-full text-sm">
                    <span>{selectedStatus}</span>
                    <button onClick={handleRemoveStatus}>✖</button>
                  </div>
                )}

                {/* Interest Level */}
                {selectedLevel && (
                  <div className="flex items-center gap-2 bg-customGreen text-white px-3 py-1 rounded-full text-sm">
                    <span>{selectedLevel.label}</span>
                    <button onClick={handleRemoveLevel}>✖</button>
                  </div>
                )}

                {/* Locations */}
                {interestLocationTags?.label && (
                  <div className="flex items-center gap-2 bg-customGreen text-white px-3 py-1 rounded-full text-sm">
                    <span>{interestLocationTags?.label}</span>
                    <button onClick={() => handleRemoveLocation()}>✖</button>
                  </div>
                )}

                {/* Team */}
                {userRole !== "BOD" && (
                  <>
                    {selectedTeam && (
                      <div className="flex items-center gap-2 bg-customGreen text-white px-3 py-1 rounded-full text-sm">
                        <span>
                        {teams.find((team) => team.teamId === selectedTeam)?.name || selectedTeam}
                        </span>
                        <button onClick={handleRemoveTeam}>✖</button>
                      </div>
                    )}
                  </>
                )}

                {/* User */}
                {selectedUser && (
                  <div className="flex items-center gap-2 bg-customGreen text-white px-3 py-1 rounded-full text-sm">
                    <span>
                      {users.find((user) => user.id === selectedUser)?.name ||
                        selectedUser}
                    </span>
                    <button onClick={handleRemoveUser}>✖</button>
                  </div>
                )}

                {/* Date Range */}
                {(startDate || endDate) && (
                  <div className="flex items-center gap-2 bg-customGreen text-white px-3 py-1 rounded-full text-sm">
                    <span>
                      Date: {startDate ? startDate.toLocaleDateString() : "?"} -{" "}
                      {endDate ? endDate.toLocaleDateString() : "?"}
                    </span>

                    <button onClick={handleRemoveDate}>✖</button>
                  </div>
                )}
              </div>
          
          </div>
        </div>
      </div>

   <BulkLeadUploadDataFilter
        visible={filterVisible}
        onHide={() => setFilterVisible(false)}
        status={status}
        selectedStatus={selectedStatus}
        handleStatusChange={handleStatusChange}
        interestLevel={interestLevel}
        selectedLevel={selectedLevel}
        handleSelectChange={handleSelectChange}
        optionLocation={optionLocation}
        interestLocationTags={interestLocationTags}
        handleLocationChange={handleLocationChange}
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
        customStyles={customStyles}
        getBackgroundClass={getBackgroundClass}
        teams={teams}
        selectedTeam={selectedTeam}
        DropdownIndicator={DropdownIndicator}
        handleTeamChange={handleTeamChange}
        errors={errors}
        users={users}
        selectedUser={selectedUser}
        setSelectedUser={setSelectedUser}
        isLoading={isLoading}
        startDate={startDate}
        setStartDate={setStartDate}
        startType={startType}
        setStartType={setStartType}
        endDate={endDate}
        setEndDate={setEndDate}
        endType={endType}
        setEndType={setEndType}
        getLocalDate={getLocalDate}
        handleApplyFilter={applyFilter}
        clearFilters={handleClearAndApplyFilter}
      /> 

      <div className="mt-[40px] px-6">
        <LeadTable
          data={leads}
          columns={columns}
          onPageChange={handlePageChange}
          selectedRows={selectedRows}
          onSelectionChange={handleSelectionChange}
          currentPage={currentPage}
          setSearchQuery={setSearchQuery}
          handleSearchLead={handleSearchLead}
          handleReasignTeam={handleReasignTeam}
          searchQuery={searchQuery}
          loading={loading}
          disPlay={false}
          pageSize={pageSize}
          nextPageToken={nextPageToken}
          prevPageToken={prevPageToken}
          hasMoreLeads={hasMoreLeads}
          handleFilterLeads={handleFilterLeads}
        />
       
      </div>
    </div>
  );
};

export default BulkLeadUploadData;
